// extracted by mini-css-extract-plugin
export default {"stickyToggle":"LandingPageView_stickyToggle__IFAL7"};